import * as React from "react";
// import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import type { ModalProps } from "@mui/material/Modal";

import { DialogueStyled } from "./dialogueStyled";

interface IDialogueBox extends ModalProps {
  onClose: (data: boolean) => void;
}
function DialogueBox({ onClose, children, ...rest }: IDialogueBox) {
  return (
    <Modal
      onClose={onClose}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      {...rest}
    >
      <DialogueStyled>
        <div style={{ outline: "none" }}>{children || <div />}</div>
      </DialogueStyled>
    </Modal>
  );
}

export default DialogueBox;
